import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import { MENU_LIQUIDACIONES } from '../../utils/constants';
import { validarSoloUnPermiso } from '../../helpers/permisos';
import { LiquidacionesBreadcrumb } from './LiquidacionesBreadcrumb';
import { GestionFacturasHome } from './gestionLiquidaciones/GestionFacturasHome';
import { AdministrarLiquidaciones } from './administrarLiquidaciones/AdministrarLiquidaciones';
import { cleanComprobantesTomados, getComprobantesTomadosPorUsuario } from '../../actions/liquidaciones/liquidaciones';
import { fetchSubTipoEfectores } from '../../actions/tipoSubtipoEfectores';
import { LiquidacionesCargaHelios } from './LiquidacionesCargaHelios';
import { GeneracionVouchersHome } from './GeneracionVouchersHome';
import { LiquidacionesCargaScienza } from './LiquidacionesCargaScienza';
import { BuscadorExpedientes } from '../MesaEntrada/BuscadorExpedientes/BuscadorExpedientes';

const style = {
  root: {
    flexGrow: 1,
  },
};

export const LiquidacionesHome = (props) => {
  const dispatch = useDispatch();
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const [activeBreadcrumb, setActiveBreadcrumb] = useState();

  const resetRouteStateAndSetActiveBreacDrumb = (item) => {
    props.location.state = { from: props.location.pathname };
    setActiveBreadcrumb(item)
  }

  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
    dispatch(cleanComprobantesTomados());
    dispatch(getComprobantesTomadosPorUsuario());
  }, [dispatch]);

  return (
    <div className={style.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <LiquidacionesBreadcrumb
            setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
            validarSoloUnPermiso={validarSoloUnPermiso}
            activeBreadcrumb={activeBreadcrumb}
            permisosUser={permisosUser}
          />
        </Grid>
        {!activeBreadcrumb && //solicitudesTomadasUsuario.length > 0 &&
          <AdministrarLiquidaciones
            type={'currentUser'}
          />
        }
        {activeBreadcrumb === MENU_LIQUIDACIONES.GESTION_FACTURAS && (
          <GestionFacturasHome
            {...props}
          />
        )}
        {activeBreadcrumb === MENU_LIQUIDACIONES.CARGA_ARCHIVO_HELIOS && (
          <LiquidacionesCargaHelios
            {...props}
          />
        )}
        {activeBreadcrumb === MENU_LIQUIDACIONES.GENERACION_VOUCHERS && (
          <GeneracionVouchersHome
            {...props}
          />
        )}
        {activeBreadcrumb === MENU_LIQUIDACIONES.CARGA_ARCHIVO_SCIENZA && (
          <LiquidacionesCargaScienza
            {...props}
          />
        )}
        {activeBreadcrumb === MENU_LIQUIDACIONES.CONSULTA_EXPEDIENTES && (
          <BuscadorExpedientes
            {...props}
          />
        )}
      </Grid>
    </div>
  );
};
